import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

// 引入公共样式
import '../src/style/common.less'
// 导入复制链接插件
import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard);
import './icons' //  全局注册svg组件
// import IconSvg from '@/components/IconSvg'
// //全局注册icon-svg
// Vue.component('icon-svg', IconSvg)
import onfreeFegist from './mode/freeFegist.js'

import onsubjectData from './mode/subjectData.js' //热门搜索数据


import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
Vue.use(Antd)
import axios from 'axios';
Vue.prototype.axios = axios;
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import getMAC from 'getmac'

import dayjs from 'dayjs';
Vue.prototype.dayjs = dayjs;

Vue.prototype.getFreeFegist = onfreeFegist.getFreeFegist; //免费试用
Vue.prototype.$subjectData = onsubjectData.subjectData; //免费试用

//引用qs
import qs from 'qs';
Vue.prototype.qs = qs;
Vue.config.productionTip = false
//引入MD5
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
//导入cookie
import cookie from "js-cookie"
//将cookie转换为 vue 原型
Vue.prototype.Cook = cookie
//埋点
// import sensors from './api/sensors.js'
// Vue.prototype.$sensors = sensors
import $ from 'jquery'
// let interfaces=require('os').networkInterfaces();
// console.log("mac=====>"+JSON.stringify(interfaces))
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')